import {
  getOrderListByPendingOrder,
  myPendingOrderDetail,
  recycle,
} from "@/apis/market";
import { StateReducer, useCreateReducer } from "@/libs/reducer";
import { useConfigStore } from "@/stores";
import { useCryptoMerchant } from "@/stores/CryptoTradingStore";
import { AHooks } from "@/types";
import { List } from "@/types/Api/Market/PendingOrder/getOrderListByPendingOrder";
import {
  PaymentType,
  PendingOrder,
} from "@/types/Api/Market/PendingOrder/myPendingOrderDetail";
import { useMount, usePagination, useRequest, useUnmount } from "ahooks";
import { Params } from "ahooks/lib/usePagination/types";
import { Toast } from "antd-mobile";
import { useNavigate, useParams } from "react-router-dom";

export enum SellingOrderStatus {
  HANGING = "Hanging",
  BUYER_REQUEST = "WaitingSellerConfirm",
  SALE_OUT = "SaleOut",
  CANCELED_SELLING = "SellerCancelsPurchase",
}

/**
 * 使用 Turn Interface to Object 插件去直接成 pagestate
 */
interface PageState {
  order?: PendingOrder;
  payment: PaymentType[];
  status?: SellingOrderStatus;
}

const pagestate = {
  order: undefined,
  payment: [],
  status: SellingOrderStatus.HANGING,
};

type ActionType = "update-order";

const stateReducer: StateReducer<PageState, ActionType> = (state, action) => {
  switch (action.type) {
    case "update-order":
      return Object.assign({}, state, {
        order: action.order,
        payment: action.payment,
        status: action.status,
      });

    default:
      return state;
  }
};
let timer: NodeJS.Timeout;
export const useSetup = () => {
  const navigate = useNavigate();
  const params = useParams();
  const cryptoMerchantStore=useCryptoMerchant();
  const [
    waitingSellerCompletesOrderDelayTime,
    waitingSellerConfirmDelayTime,
    buyerPaysOvertimeDelayTime,
  ] = useConfigStore((state) => [
    state.waitingSellerCompletesOrderDelayTime,
    state.waitingSellerConfirmDelayTime,
    state.buyerPaysOvertimeDelayTime,
  ]);
  const [state, dispatch] = useCreateReducer<PageState, ActionType>(
    stateReducer,
    pagestate,
    {},
  );

  const load = useRequest(
    async () => {
      const response = await myPendingOrderDetail({
        pendingOrderId: Number(params.pendingOrderId!),
      },{sellerType:cryptoMerchantStore.ApiPath});

      if (response.ok) {
        // debugger;
        let status = SellingOrderStatus.HANGING;

        if (response.data!.pendingOrder.underwayOrder > 0) {
          status = SellingOrderStatus.BUYER_REQUEST;
          books.run({ current: 1, pageSize: books.pagination.pageSize });
        }

        if (response.data!.pendingOrder.status === 0) {
          if (
            response.data?.pendingOrder.amount ===
              response.data?.pendingOrder.soldAmount
          ) {
            status = SellingOrderStatus.SALE_OUT;
          } else {
            status = SellingOrderStatus.CANCELED_SELLING;
          }
        }

        dispatch({
          type: "update-order",
          order: response.data!.pendingOrder,
          payment: response.data!.paymentType,
          status,
        });

        if (response.data!.pendingOrder.status !== 0) {
          timer = setTimeout(() => load.run(), 10 * 1000);
        }
      } else {
        // TODO: 处理失败
      }
    },
    { manual: true },
  );

  const books = usePagination<AHooks.Data<List>, Params>(
    async ({ current, pageSize }) => {
      const response = await getOrderListByPendingOrder({
        pendingOrderId: Number(params.pendingOrderId!),
        page: current,
        pageSize,
      },{
        sellerType: cryptoMerchantStore.ApiPath
      });

      if (response.ok) {
        return {
          total: response.data!.total,
          list: response.data!.list,
        };
      } else {
        return {
          total: 0,
          list: [],
        };
      }
    },
    { defaultCurrent: 1, defaultPageSize: 20, manual: true },
  );

  const cancel = useRequest(
    async () => {
      const response = await recycle({
        pendingOrderId: Number(params.pendingOrderId!),
      },{
        sellerType: cryptoMerchantStore.ApiPath
      });
      if (response.ok) {
        navigate(-1);
      } else {
        Toast.show(response.msg);
      }
    },
    { manual: true },
  );

  useMount(() => {
    load.run();
  });

  useUnmount(() => {
    clearTimeout(timer);
  });
  return {
    state,
    dispatch,
    load,
    books,
    cancel,
    navigate,
    orderDurations: {
      waitingSellerCompletesOrderDelayTime,
      waitingSellerConfirmDelayTime,
      buyerPaysOvertimeDelayTime,
    },
    cryptoMerchantStore
  };
};
